import { messages } from './EmailToCounterpartySection.messages';

export const purchaseOrderLabels = {
    title: messages.vendorEmailSectionText,
    attachmentsTitle: messages.attachmentsToVendorTitle,
};

export const salesInvoiceLabels = {
    title: messages.customerEmailSectionText,
    attachmentsTitle: messages.attachmentsToCustomerTitle,
};
